import { useQuery } from "@tanstack/react-query";
import { fetchUsageVideos, fetchOneUsageVideo } from "services/usageApi";

const useQuerieUsageVideos = (lang, page) => {
  const { data, isPending, isFetching } = useQuery({
    queryKey: ["usages-videos", lang, page],
    queryFn: fetchUsageVideos,
  });
  return [
    { data: data?.data.rows ?? [], dataCount: data?.data.count ?? 0 },
    isFetching,
  ];
};
const useQuerieUsageOneVideo = (params) => {
  const { data, isPending, isFetching } = useQuery({
    queryKey: ["usage-one-video", params],
    queryFn: fetchOneUsageVideo,
  });
  return [data?.data ?? [], isFetching];
};
export { useQuerieUsageVideos, useQuerieUsageOneVideo };
